import React from 'react';
import { Navbar, Nav, Button, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Imagedonatelogo from '../images/website_logo.png';

const Header: React.FC = () => {
  const handleNavLinkClick = () => {
    const navbarToggler = document.querySelector('.navbar-toggler') as HTMLButtonElement | null;
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarCollapse?.classList.contains('show') && navbarToggler) {
      navbarToggler.click();
    }
  };

  return (
    <>
      <Navbar bg="light" variant="light" expand="lg" fixed="top" className="header px-5">
        <Navbar.Brand as={Link} to="/" aria-label="Srisailam Foundation Home">
          <img src={Imagedonatelogo} alt="Srisailam Foundation logo" className="header-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="bg-dark border-dark" aria-label="Toggle navigation menu" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Home
            </Nav.Link>
            <NavDropdown title="About" id="about-us-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/about/" onClick={handleNavLinkClick}>
                About Srisailam Foundation
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/core-team/" onClick={handleNavLinkClick}>
                Leadership Team
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/mentors/" onClick={handleNavLinkClick}>
                Advisory Mentors
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Programs" id="our-mission-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/education/" onClick={handleNavLinkClick}>
                Education
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/women-empowerment/" onClick={handleNavLinkClick}>
                Women Empowerment
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/environment/" onClick={handleNavLinkClick}>
                Environment
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/health/" onClick={handleNavLinkClick}>
                Health
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/livelihood/" onClick={handleNavLinkClick}>
                Livelihood
              </NavDropdown.Item>
            </NavDropdown>
            {/* <Nav.Link as={Link} to="/media/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Media & Gallery
            </Nav.Link> */}
            <Nav.Link as={Link} to="/blogs/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Stories
            </Nav.Link>
            <NavDropdown title="Get Involved" id="get-involved-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/become-member/" onClick={handleNavLinkClick}>
                Join as Member
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/volunteer" onClick={handleNavLinkClick}>
                Volunteer With Us
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/contact/" onClick={handleNavLinkClick}>
                Contact
              </NavDropdown.Item>
            </NavDropdown>
            <Link to="/donate/" className="nav-link-custom" onClick={handleNavLinkClick}>
              <Button variant="danger" className="header-donate-btn">
                Donate Now
              </Button>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Header;
